import { Select, SelectOption } from '../index';
import { useIntl } from 'react-intl';

type TransactionTypeKey = 'e-market' | 'purchase' | 'reservation' | 'dynamic_purchase' | 'order';

interface TransactionTypeSelectorProps {
  availableOptions?: string[];
  includeEmarket?: boolean;
  name?: string;
  label?: string;
  customLabels?: Partial<Record<TransactionTypeKey, string>>;
  style?: React.CSSProperties;
}

const defaultLabels: Record<TransactionTypeKey, string> = {
  'e-market': 'transactions.type.e_market',
  'purchase': 'listing.transaction_type.purchase',
  'reservation': 'listing.transaction_type.public.reservation',
  'dynamic_purchase': 'listing.transaction_type.dynamic_purchase',
  'order': 'listing.transaction_type.order',
};

export const TransactionTypeSelector = ({
  availableOptions,
  includeEmarket = false,
  name = 'transaction_type',
  label,
  customLabels,
  style,
}: TransactionTypeSelectorProps) => {
  const intl = useIntl();

  const getLabel = (key: TransactionTypeKey) =>
    intl.formatMessage({ id: customLabels?.[key] || defaultLabels[key] });

  const allTransactionTypeOptions = [
    ...(includeEmarket
      ? [{ value: 'e-market' as const, label: getLabel('e-market') }]
      : []),
    { value: 'purchase' as const, label: getLabel('purchase') },
    { value: 'reservation' as const, label: getLabel('reservation') },
    { value: 'dynamic_purchase' as const, label: getLabel('dynamic_purchase') },
    { value: 'order' as const, label: getLabel('order') },
  ];

  const transactionTypeOptions = availableOptions
    ? allTransactionTypeOptions.filter(option => availableOptions.includes(option.value))
    : allTransactionTypeOptions;

  return (
    <Select
      name={name}
      label={label || intl.formatMessage({ id: 'listing.filter.transaction_type' })}
      placeholder={intl.formatMessage({ id: 'listing.filter.select_transaction_type' })}
      allowClear
      style={style}
    >
      {transactionTypeOptions.map((option) => (
        <SelectOption key={option.value} value={option.value}>
          {option.label}
        </SelectOption>
      ))}
    </Select>
  );
};
